module.exports = "/static/assets/5bfff9bf12488459f68ffb3428d8dcb5.png";